import { Routes, Route, Navigate } from 'react-router-dom';
import { AdminLayout } from './admin/AdminLayout';
import { TopicsPage } from './admin/pages/TopicsPage';
import { TopicCreatePage } from './admin/pages/TopicCreatePage';
import { TopicEditPage } from './admin/pages/TopicEditPage';
import { EpisodesPage } from './admin/pages/EpisodesPage';
import { EpisodeDetailPage } from './admin/pages/EpisodeDetailPage';
import { FeaturesPage } from './admin/pages/FeaturesPage';
import { InviteManagement } from './admin/components/InviteManagement';
import { SourceSettingsEditor } from './admin/components/SourceSettingsEditor';
import { PromptTemplateEditor } from './admin/components/PromptTemplateEditor';
import { AuthProvider } from '@/lib/auth/AuthContext';
import { FeatureFlagProvider } from '@/features';
import { RelayProvider } from '@/providers/RelayProvider';
import { LoginPage as AdminLoginPage } from './admin/components/LoginPage';
import { AuthCallback } from './admin/components/AuthCallback';
import { ProtectedRoute, ProtectedUserRoute } from './admin/components/ProtectedRoute';
import { LoginPage } from './pages/LoginPage';
import { LoginCallback } from './pages/LoginCallback';
import { Homepage } from './components/Homepage';
import { RequestInvitePage } from './components/RequestInvitePage';
import { InviteRedemption } from './components/InviteRedemption';
import { VerifyEmail } from './components/VerifyEmail';
import { PodcastPage } from './pages/PodcastPage';
import { ProfilePage } from './pages/ProfilePage';
import { PlayerProvider } from '@/lib/PlayerContext';
import { GlobalPlayer } from './components/GlobalPlayer';
import { DashboardLayout } from './dashboard/DashboardLayout';
import { DashboardHome } from './dashboard/pages/DashboardHome';
import { FollowingPage } from './dashboard/pages/FollowingPage';
import { LikedEpisodesPage } from './dashboard/pages/LikedEpisodesPage';
import { HistoryPage } from './dashboard/pages/HistoryPage';
import { DiscoverPage } from './dashboard/pages/DiscoverPage';

function App() {
  return (
    <AuthProvider>
      <FeatureFlagProvider>
        <RelayProvider>
          <PlayerProvider>
          <Routes>
            <Route path="/admin/login" element={<AdminLoginPage />} />
            <Route path="/admin/callback" element={<AuthCallback />} />
            <Route
              path="/admin"
              element={
                <ProtectedRoute>
                  <AdminLayout />
                </ProtectedRoute>
              }
            >
              <Route index element={<Navigate to="/admin/topics" replace />} />
              <Route path="topics" element={<TopicsPage />} />
              <Route path="topics/create" element={<TopicCreatePage />} />
              <Route path="topics/:slug/edit" element={<TopicEditPage />} />
              <Route path="episodes" element={<EpisodesPage />} />
              <Route path="episodes/:topicSlug" element={<EpisodesPage />} />
              <Route path="episodes/:topicSlug/:episodeId" element={<EpisodeDetailPage />} />
              <Route path="invites" element={<InviteManagement />} />
              <Route path="features" element={<FeaturesPage />} />
              <Route path="sources" element={<SourceSettingsEditor />} />
              <Route path="prompt" element={<PromptTemplateEditor />} />
            </Route>
            <Route path="/login" element={<LoginPage />} />
            <Route path="/login/callback" element={<LoginCallback />} />
            <Route
              path="/dashboard"
              element={
                <ProtectedUserRoute>
                  <DashboardLayout />
                </ProtectedUserRoute>
              }
            >
              <Route index element={<DashboardHome />} />
              <Route path="following" element={<FollowingPage />} />
              <Route path="liked" element={<LikedEpisodesPage />} />
              <Route path="history" element={<HistoryPage />} />
              <Route path="discover" element={<DiscoverPage />} />
            </Route>
            <Route
              path="/profile"
              element={
                <ProtectedUserRoute>
                  <ProfilePage />
                </ProtectedUserRoute>
              }
            />
            <Route path="/p/:slug" element={<PodcastPage />} />
            <Route path="/request-invite" element={<RequestInvitePage />} />
            <Route path="/invite/:token" element={<InviteRedemption />} />
            <Route path="/verify-email/:token" element={<VerifyEmail />} />
            <Route path="/" element={<Homepage />} />
          </Routes>
          <GlobalPlayer />
          </PlayerProvider>
        </RelayProvider>
      </FeatureFlagProvider>
    </AuthProvider>
  );
}

export default App;
